module.exports = __webpack_public_path__ + "static/media/h_01.e3420278.png";